// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2zAU7","alert":"SettungsInbox_alert__21W7x"};